import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

import { Link } from "features/links/links";
import { FeatureNode, NodesInjectionKey } from "game/layers";
import { computed, inject, nextTick, onMounted, ref, toRef } from "vue";
import LinkVue from "./Link.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    links: null
  },
  setup(__props: any) {

const _props = __props as { links?: Link[] }


const links = toRef(_props, "links");

const resizeObserver = new ResizeObserver(updateNodes);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const nodes = inject(NodesInjectionKey)!;

const resizeListener = ref<Element | null>(null);

onMounted(() => {
    // ResizeListener exists because ResizeObserver's don't work when told to observe an SVG element
    const resListener = resizeListener.value;
    if (resListener != null) {
        resizeObserver.observe(resListener);
    }
});

let isDirty = true;
let boundingRect = ref(resizeListener.value?.getBoundingClientRect());
function updateNodes() {
    if (resizeListener.value != null && isDirty) {
        isDirty = false;
        nextTick(() => {
            boundingRect.value = resizeListener.value?.getBoundingClientRect();
            (Object.values(nodes.value) as FeatureNode[]).forEach(
                node => (node.rect = node.element.getBoundingClientRect())
            );
            isDirty = true;
        });
    }
}
document.fonts.ready.then(updateNodes);

const validLinks = computed(() => {
    const n = nodes.value;
    return (
        links.value?.filter(link => n[link.startNode.id]?.rect && n[link.startNode.id]?.rect) ?? []
    );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(validLinks))
      ? (_openBlock(), _createElementBlock("svg", _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(validLinks), (link, index) => {
            return (_openBlock(), _createBlock(LinkVue, {
              key: index,
              link: link,
              boundingRect: _unref(boundingRect),
              startNode: _unref(nodes)[link.startNode.id]!,
              endNode: _unref(nodes)[link.endNode.id]!
            }, null, 8, ["link", "boundingRect", "startNode", "endNode"]))
          }), 128))
        ], 16))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "resizeListener",
      ref: resizeListener,
      class: "resize-listener"
    }, null, 512)
  ], 64))
}
}

})